import * as fromAlarms from '@core/reducers/alarm.reducer';
import * as fromAuth from '@core/reducers/auth.reducer';
import * as fromAutocomplete from '@core/reducers/autocomplete.reducer';
import * as fromBrands from '@core/reducers/brand.reducer';
import * as fromBriefs from '@core/reducers/brief.reducer';
import * as fromBusinessUnits from '@core/reducers/business-unit.reducer';
import * as fromColorBussiness from '@core/reducers/color-bussiness.reducer';
import * as fromColors from '@core/reducers/color.reducer';
import * as fromComments from '@core/reducers/comment.reducer';
import * as fromCountryDepartments from '@core/reducers/country-department.reducer';
import * as fromCountries from '@core/reducers/country.reducer';
import * as fromCover from '@core/reducers/cover.reducer';
import * as fromDepartamentsBusinessColor from '@core/reducers/departaments-business-color.reducer';
import * as fromDepartmentsFood from '@core/reducers/department-food.reducer';
import * as fromDepartments from '@core/reducers/department.reducer';
import * as fromDestinationCenters from '@core/reducers/destination-center.reducer';
import * as fromDestinations from '@core/reducers/destination.reducer';
import * as fromFiles from '@core/reducers/file.reducer';
import * as fromFilters from '@core/reducers/filter.reducer';
import * as fromFollowCountries from '@core/reducers/follow-country.reducer';
import * as fromFollowGroups from '@core/reducers/follow-group.reducer';
import * as fromFollowShipments from '@core/reducers/follow-shipment.reducer';
import * as fromFollows from '@core/reducers/follow.reducer';
import * as fromFollowArrivals from '@core/reducers/followarrival.reducer';
import * as fromHangers from '@core/reducers/hanger.reducer';
import * as fromJob from '@core/reducers/job.reducer';
import * as fromManagement from '@core/reducers/management.reducer';
import * as fromMe from '@core/reducers/me.reducer';
import * as fromMembers from '@core/reducers/member.reducer';
import * as fromMilestones from '@core/reducers/milestone.reducer';
import * as fromNotifications from '@core/reducers/notification.reducer';
import * as fromPackaging from '@core/reducers/packaging.reducer';
import * as fromPackagingManagers from '@core/reducers/packaging-manager.reducer';
import * as fromPlannerIds from '@core/reducers/planner-id.reducer';
import * as fromPorts from '@core/reducers/port.reducer';
import * as fromProductArrivals from '@core/reducers/product-arrivals.reducer';
import * as fromProductCountries from '@core/reducers/product-country.reducer';
import * as fromProductShipments from '@core/reducers/product-shipment.reducer';
import * as fromProducts from '@core/reducers/product.reducer';
import * as fromProformas from '@core/reducers/proforma.reducer';
import * as fromProviders from '@core/reducers/provider.reducer';
import * as fromReports from '@core/reducers/reports.reducer';
import * as fromRetroplannings from '@core/reducers/retroplanning.reducer';
import * as fromRules from '@core/reducers/rule.reducer';
import * as fromSarState from '@core/reducers/sar_state.reducer';
import * as fromSeasons from '@core/reducers/season.reducer';
import * as fromShipment from '@core/reducers/shipment.reducer';
import * as fromShippingTimes from '@core/reducers/shipping-time.reducer';
import * as fromSustainability from '@core/reducers/sustainability.reducer';
import * as fromUserBusinesses from '@core/reducers/user-business.reducer';
import * as fromUsers from '@core/reducers/user.reducer';

import { ActionReducerMap } from '@ngrx/store';

export interface State {
  me: fromMe.State;
  colors: fromColors.State;
  briefs: fromBriefs.State;
  autocomplete: fromAutocomplete.State;
  brands: fromBrands.State;
  comments: fromComments.State;
  files: fromFiles.State;
  countries: fromCountries.State;
  departments: fromDepartments.State;
  products: fromProducts.State;
  productCountries: fromProductCountries.State;
  seasons: fromSeasons.State;
  filters: fromFilters.State;
  users: fromUsers.State;
  businessUnits: fromBusinessUnits.State;
  follows: fromFollows.State;
  followCountries: fromFollowCountries.State;
  providers: fromProviders.State;
  shippingTimes: fromShippingTimes.State;
  notifications: fromNotifications.State;
  ports: fromPorts.State;
  auth: fromAuth.State;
  members: fromMembers.State;
  plannerIds: fromPlannerIds.State;
  followShipments: fromFollowShipments.State;
  productShipments: fromProductShipments.State;
  hangers: fromHangers.State;
  alarms: fromAlarms.State;
  destinations: fromDestinations.State;
  proformas: fromProformas.State;
  followGroups: fromFollowGroups.State;
  milestones: fromMilestones.State;
  rules: fromRules.State;
  countryDepartments: fromCountryDepartments.State;
  destinationCenters: fromDestinationCenters.State;
  reports: fromReports.State;
  userBusinesses: fromUserBusinesses.State;
  //fileUpload: fromNewProductFile.State;
  sarStates: fromSarState.State;
  jobs: fromJob.State;
  managements: fromManagement.State;
  packaging: fromPackaging.State;
  packagingManagers: fromPackagingManagers.State;
  sustainability: fromSustainability.State;
  cover: fromCover.State;
  shipments: fromShipment.State;
  retroplannings: fromRetroplannings.State;
  departmentsFood: fromDepartmentsFood.State;
  colorBussinesses: fromColorBussiness.State;
  departamentsBusinessColor: fromDepartamentsBusinessColor.State;
  followArrivals: fromFollowArrivals.State;
  productArrivals: fromProductArrivals.State
}

export const reducers: ActionReducerMap<State> = {
  me: fromMe.reducer,
  colors: fromColors.reducer,
  briefs: fromBriefs.reducer,
  rules: fromRules.reducer,
  departments: fromDepartments.reducer,
  products: fromProducts.reducer,
  files: fromFiles.reducer,
  countries: fromCountries.reducer,
  seasons: fromSeasons.reducer,
  users: fromUsers.reducer,
  filters: fromFilters.reducer,
  businessUnits: fromBusinessUnits.reducer,
  follows: fromFollows.reducer,
  comments: fromComments.reducer,
  brands: fromBrands.reducer,
  autocomplete: fromAutocomplete.reducer,
  providers: fromProviders.reducer,
  shippingTimes: fromShippingTimes.reducer,
  productCountries: fromProductCountries.reducer,
  notifications: fromNotifications.reducer,
  ports: fromPorts.reducer,
  followCountries: fromFollowCountries.reducer,
  auth: fromAuth.reducer,
  members: fromMembers.reducer,
  plannerIds: fromPlannerIds.reducer,
  followShipments: fromFollowShipments.reducer,
  productShipments: fromProductShipments.reducer,
  productArrivals: fromProductArrivals.reducer,
  hangers: fromHangers.reducer,
  alarms: fromAlarms.reducer,
  destinations: fromDestinations.reducer,
  proformas: fromProformas.reducer,
  followGroups: fromFollowGroups.reducer,
  milestones: fromMilestones.reducer,
  countryDepartments: fromCountryDepartments.reducer,
  destinationCenters: fromDestinationCenters.reducer,
  reports: fromReports.reducer,
  userBusinesses: fromUserBusinesses.reducer,
  //fileUpload: fromNewProductFile.reducer
  jobs: fromJob.reducer,
  sarStates: fromSarState.reducer,
  managements: fromManagement.reducer,
  packaging: fromPackaging.reducer,
  packagingManagers: fromPackagingManagers.reducer,
  sustainability: fromSustainability.reducer,
  cover: fromCover.reducer,
  shipments: fromShipment.reducer,
  retroplannings: fromRetroplannings.reducer,
  departmentsFood: fromDepartmentsFood.reducer,
  colorBussinesses: fromColorBussiness.reducer,
  departamentsBusinessColor: fromDepartamentsBusinessColor.reducer,
  followArrivals: fromFollowArrivals.reducer
};
